import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

// bayclubs module
import { UtilsModule } from '@bayclubs/utils';
import { DropDownModule } from '@bayclubs/drop-down';

// application components
import { DashboardComponent } from './routes/dashboard/dashboard.component';
import { ShellComponent } from './routes/shell/shell.component';
import { BcEmployeeOAuthCallbackComponent } from '@bayclubs/employee-auth';
import { createHorizonErrorRoutes, createHorizonLoginRoutes } from '@bayclubs/horizon';

// application services


export const coreRoutes: Routes = [
    // this have to be relative redirect. Otherwise query params are not retained and the auto login feature not working
    { path: '', redirectTo: 'management/classes/calendar', pathMatch: 'full' },
    ...createHorizonLoginRoutes(),
    { path: 'code', component: BcEmployeeOAuthCallbackComponent },
    ...createHorizonErrorRoutes(),
];

@NgModule({
    declarations: [
        DashboardComponent,
        ShellComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(coreRoutes),
        TranslateModule.forChild(),
        UtilsModule,
        DropDownModule
    ],
    providers: []
})
export class CoreModule {}

export { AuthService } from './services/auth.service';
